import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import ReactTooltip from 'react-tooltip';
import { useIntl } from 'react-intl';

const SwitchCheckbox = props => {

    const { inputData: { checked, id, valueToPass, disabled, tooltipText } = {}, label: { text, labelClass } = {} } = props;
    const intlApi = useIntl();

    useEffect(() => {
        ReactTooltip.rebuild();
    }, [checked, disabled, tooltipText]);

    const handleChange = () => {
        props.inputActions.handleFieldChange(!checked, valueToPass);
    };

    return (
        <Form id={id}>
            <Form.Check
                data-tip={disabled && tooltipText ? (intlApi.formatMessage({ id: tooltipText })) : null}
                type="switch"
                id={id}
                label={<span className={`instruction_link ${labelClass && labelClass.join(' ')}`}>{text}</span>}
                checked={checked}
                style={{ paddingLeft: '4rem' }}
                onChange={handleChange}
                disabled={disabled}
                aria-label={`${text} checkbox`}
            />
            <ReactTooltip effect="solid" place="top" /> 
        </Form>
    );
};

export default SwitchCheckbox;
